import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import { Color as AlertColor } from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

import { SavingStatus } from '../../../../types';
import { Props as HeaderProps } from '../../Header';
import { StyledAlert, StyledProgress } from './styled';

const SavingStatusAlert = (props: Pick<HeaderProps, 'savingStatus' | 'retrySave'>) => {
    const { savingStatus, retrySave } = props;

    const { t } = useTranslation();

    const statusDescriptions = useMemo((): { [key in SavingStatus]: string } => {
        return {
            pending: t('pages.plastic_assessment.tabs.kpi.saving_data'),
            success: t('pages.plastic_assessment.tabs.kpi.saved_data'),
            failed: t('pages.plastic_assessment.tabs.kpi.error_saving_data')
        };
    }, [t]);

    const statusColor = useMemo((): { [key in SavingStatus]: AlertColor } => {
        return {
            pending: 'info',
            success: 'success',
            failed: 'error'
        };
    }, []);

    return (
        <StyledAlert severity={statusColor[savingStatus]}>
            <AlertTitle>
                <>
                    {statusDescriptions[savingStatus]}

                    {savingStatus === 'pending' && <StyledProgress />}
                </>
            </AlertTitle>

            {savingStatus === 'failed' && (
                <Button variant='outlined' color='primary' onClick={() => retrySave()} >
                    {t('pages.plastic_assessment.tabs.kpi.click_for_retry')}
                </Button>
            )}
        </StyledAlert>
    );
};

export default SavingStatusAlert;